/** list of object typeids used on objects which are pseudo properties (and therefore might be processed erroneously as edges ) */

export const attributeObjectTypeIds = ['DeviceConfig', 'DeviceControlTransaction', 'Incident', 'ObjectHistory', 'ObservationHistory', 'ThingShadowState']
